app.service('accountChangePaymentView', function (modal, loading, pageConfig, validate, message) {
	var $self, $result, $form, payUMode, $shopsBox, $shops, store_code;
	var config;
	var firstError=false;
	var paymentTypeName=null;

	function loadPaymentData(params){
		loading.start();
		var data={
			orderNumber: config.orderNumber,
			paymentTypeName: paymentTypeName,
			usePaymentModuleOperator: config.usePaymentModuleOperator
		};
		$.extend(true, data, params);
		paymentTypeName=data.paymentTypeName;
		$.ajax({
			url: '/customer-change-payment-type-additional-sections.ltr',
			type:'POST',
			data:data,
			success:function(html){
				$result.html(html);
				if(paymentTypeName=='PAYU_INSTALMENTS'){
					initPayUOfferModal();
				}
				initSearchCity();
				initValidate();
				setRegulationUrl();
			},
			error:function(){
				modal.alert('Błąd pobierania danych');
			},
			complete:function(){
				loading.stop();
			}
		})
	}
	function initValidate(){
		$form = $result.find('form');
		if($form.length){
			validate.task('changePayment', {$form: $form, payUMode:payUMode, send: function(){
				if(payUMode){
					loading.start();
					$form[0].submit();
				}else{
					send();
				}
			}});
		}
	}
	function setRegulationUrl() {
		var regulationUrl = $('#payment-regulation-url').val();
		if (regulationUrl) {
			$('.js-payment-regulation a').attr('href', regulationUrl);
		}
	}
	function checkFormValidationAndSubmit() {
		if($form.length && $form.valid()){
			$form.submit();
		}
	}
	function send(){
		function firstErrorModal(){
			loading.start();
			message.get('customer-change-payment-type.bhtml-error-20-first').then(function(result){
				loading.stop();
				modal.generate({
					id:'change-payment-message-1',
					content:result+`<p style="text-align:center"><button class="close-modal js-close-modal">Zamknij</button></p>`,
					callbackClose:function(){
						firstError=true;
					}
				});
			});
		}
		function secondErrorModal(){
			loading.start();
			message.get('customer-change-payment-type.bhtml-error-20-second').then(function(result){
				loading.stop();
				modal.generate({
					id:'change-payment-message-2',
					content:result+`<p style="text-align:center"><button class="close-modal js-close-modal">Przejdź do konta klienta</button></p>`,
					callbackClose:function(){
						loading.redirect('/konto.bhtml');
					}
				});
			});

		}
		loading.start();
		var data=$form.serializeArray();
		data.push({
			name: 'orderNumber', value: config.orderNumber
		});
		$.ajax({
			url:'/customer-change-payment-type.bhtml',
			type:'POST',
			data:data,
			success:function(result){
				loading.stop();

				if(result.status == 'SUCCESS' && result.goToPaymentModule == true){
					loading.redirect('/konto-platnosc.bhtml?orderNumber=' + config.orderNumber);
				} else if(result.status == 'SUCCESS') {
					loading.redirect('/customer-order-preview.bhtml?orderNumber='+config.orderNumber+'&changePaymentType=true');
				} else if (result.status == 'OUT_OF_DATE_CALENDAR' && !firstError){
					firstErrorModal();
				} else{
					secondErrorModal();
				}
			},
			error:function(){
				loading.stop();
				modal.alert('błąd wysyłania danych. Spróbuj ponownie');
			}
		});
	}

	function showDeliveryDayMessage(date) {
		var $deliveryDayMessage = $self.find('.delivery-day-message');
		$deliveryDayMessage.removeClass('is-visible');
		$deliveryDayMessage.filter('[data-date="' + date + '"]').addClass('is-visible');
	}

	function preValidateForPayuPriceLimitMessage(params, callback = function(){}) {
		var url = params.dayIndex != null ? '/customer-change-payment-type-select-day.bhtml' : '/customer-change-payment-type-select-interval.bhtml';
		var data={
			orderNumber: config.orderNumber,
			paymentTypeName: paymentTypeName,
		};
		$.extend(true, data, params);
		loading.start();
		$.ajax({
			url:url,
			type:'POST',
			data:data,
			success:function(json){
				loading.stop();
				if(json.errorMessage != ''){
					modal.generate({
						id:'modal-payu-price-limit-message',
						closeOnEscape:false,
						close:false,
						content: json.errorMessage,
						buttons : [
							{
								text: 'Rozumiem',
								cssClass: 'confirm-button',
								click: function () {
									modal.close();
								}
							}
						]
					});
				} else {
					callback();
				}
			},
			error:function(){
				loading.stop();
				modal.alert('Błąd wysyłania danych. Spróbuj ponownie');
			}
		});
	}
	function setElements(){
		$self = $('#account-change-payment, #account-change-delivery-time');
		payUMode = $('#account-change-delivery-time').length == 1;
		$result = $('#payment-type-box');
		config = pageConfig.getData('account');
	}
	function setEvents(){
		$self.on('click', '.js-change-payment', function(){
			$('.js-change-payment').removeClass('selected');
			$(this).addClass('selected');
			loadPaymentData({paymentTypeName: $(this).data('name'), shopCode: null});
		}).on('click', '.js-bank-select', function(){
			$('.js-bank-select').removeClass('active');
			$(this).addClass('active');
			loadPaymentData({ePaymentBankId: $(this).data('bank')});
		}).on('click', '.js-set-day', function(){
			$('.js-set-day').removeClass('selected');
			$(this).addClass('selected');
			if($(this).data('date')){
				showDeliveryDayMessage($(this).data('date'));
			}
			if($(this).data('interval')){
				setInterval($(this).data('interval'), $(this).data('total'));
			}else{
				$('.hourly-intervals').removeClass('selected').filter('.hourly-intervals-'+$(this).data('index')).addClass('selected');
				$('.delivery-cost-total').removeClass('visible');
				$('input[name=deliveryInterval]').val('');
				$('input[name=interval]:checked').prop('checked', false);
			}
			preValidateForPayuPriceLimitMessage({dayIndex: $(this).data('index')/1 - 1}); // pobierany index jest iteracją dla listy z forEach, więc potrzebne jest jego pomniejszenie

		}).on('click', '.js-reset-shop', function(){
			$('.last-shop').remove();
			$.scrollTo($('#shops-list'));
			//loadPaymentData({paymentTypeName: $(this).data('name'), shopCode: ""});
		}).on('click', '.js-change-payment-back', function(){
			loading.redirect('/customer-current-orders.bhtml');
		}).on('click', '.js-change-payment-next', function(){
			var deliveryIntervalVal = $('input[name=deliveryInterval]').val();
			if (deliveryIntervalVal) {
				preValidateForPayuPriceLimitMessage({deliveryInterval: deliveryIntervalVal}, function(){
					checkFormValidationAndSubmit();
				});
			} else {
				checkFormValidationAndSubmit();
			}
		}).on('click', '.js-search-city', function(){
			searchShops({city: $('#shop-city').val()});
		}).on('click', '.js-search-zipcode', function(){
			searchShops({zipCode: $('#shop-zipCode').val()});
		}).on('change', '#shop-city', function(event){
			searchShops({city: $('#shop-city').val()});
		}).on('click', 'input[name=interval]', function(){
			setInterval($(this).val(), $(this).data('total'));
			preValidateForPayuPriceLimitMessage({deliveryInterval: $(this).val()});
		}).on('click', '.js-show-hours', function(){
			$(this).closest('.shop-item').toggleClass('show-hours');
		}).on('click', '.shop-item', function(event){
			if(!$(event.target).hasClass('js-show-hours') && !$(event.target).hasClass('js-reset-shop')){
				$shops.removeClass('selected');
				store_code=$(this).data('code');
				$shopsBox.addClass('one-shop-selected hide-search-bar');
				$(this).addClass('selected');
				var zipCode = $('#shop-zipCode').val();
				var cityCode = $('#shop-city').val();
				loadPaymentData({paymentTypeName: 'INSTALMENT', shopCode: $(this).data('code'), zipCode: zipCode && zipCode.length ? zipCode : undefined, city:cityCode ? cityCode : undefined});
			}
		});
	}
	function setInterval(hash, total){
		$('.delivery-cost-total').addClass('visible').find('strong').text(total);
		$('input[name=deliveryInterval]').val(hash).valid();
	}
	function initPayUOfferModal(){
		var $payUMessage = $('.payu-message-description');
		if($payUMessage.length) {
			$('.js-show-payu-offer-modal', $payUMessage).on('click', function(){
				modal.open('about-payu-instalments');
			});
			if (config.selectPayUDetails) {
				config.selectPayUDetails = false;
				$('.js-show-payu-offer-modal').trigger('click');
			}
		}
	}
	function initSearchCity(){
		$('.select3-input', $result).select3();
		$('#shop-zipCode').keyfilter(/[\d\-]/).mask2("99-999");
		$shopsBox = $('#shops-list');
		$('#shop-zipCode').keyup(function(event){
			console.log(event.keyCode)
			if (event.keyCode === 13) {
				searchShops({zipCode: $('#shop-zipCode').val()});
			}
			// event.preventDefault();
			// event.stopPropagation();
		});
		$shops = $shopsBox.find('.shop-item');
	}
	function searchShops(params){
		var $error = $('.shop-error-search').hide();
		var $list = $('.shops-list', $shopsBox);
		var data={
			orderNumber: config.orderNumber,
			location: 'change_payment'
		};
		if(/^[0-9]{2}\-[0-9]{3}$/.test(params.zipCode)){
			data.zipCode= params.zipCode;
			$('#shop-city').val('');
		}else if(params.city && (""+params.city).length){
			data.city= params.city;
			$('#shop-zipCode').val('');
		}
		if(store_code){
			data.store_code=store_code;
		}
		if(data.city || data.zipCode){
			$list.addClass('loading');
			$.ajax({
				url:'/customer-order-select-shop.ltr',
				data:data,
				success:function(html){
					$shopsBox.html(html);
					success();
				},
				error:function(){
					modal.alert('Błąd pobieranie danych');
					$list.removeClass('loading');
				},
				complete:function(){
				}
			});
		}else{
			var text = 'Wpisz poprawny kod pocztowy lub wybierz miasto';
			if(params.zipCode && params.zipCode.length && !/^[0-9]{2}\-[0-9]{3}$/.test(params.zipCode)){
				text='Wypełnij poprawnie kod pocztowy';
			}else if(params.city && !params.city.length){
				text='Wybierz miejscowość z listy';
			}
			$error.text(text).show();
		}

		function success(){
			initSearchCity();
			if($shops.length){
				$shopsBox.addClass('has-shops');
			}else{
				$shopsBox.removeClass('has-shops')
			}
		}
	}

	function init() {
		setElements();
		setEvents();
		initValidate();
		if (config.selectPayUInstalment) {
			var $payUSelect = $('.js-change-payment[data-name="PAYU_INSTALMENTS"]');
			if ($payUSelect.length) {
				$payUSelect.trigger('click');
			}
		}
	}

	return {
		init
	};
});
